import type { ReactNode } from "react";
import { isApiError } from "@/api/client";

export function ErrorState({
  error,
  onRetry,
  className = "",
  children,
}: {
  error: unknown;
  onRetry?: () => void;
  className?: string;
  children?: ReactNode;
}) {
  let title = "Request failed";
  let detail: string | undefined;
  if (isApiError(error)) {
    title =
      error.code === "unavailable"
        ? "Store unavailable"
        : error.code === "not_found"
          ? "Not found"
          : error.code === "no_mark"
            ? "No mark yet"
            : `Error ${error.status}`;
    detail = error.message;
  } else if (error instanceof Error) {
    detail = error.message;
  }
  return (
    <div
      className={`flex h-full min-h-24 flex-col items-center justify-center gap-1 p-4 text-center ${className}`}
      role="alert"
    >
      <div className="text-sm text-danger">{title}</div>
      {detail && <div className="max-w-md text-[11px] text-fg-muted">{detail}</div>}
      {children}
      {onRetry && (
        <button type="button" className="ctl mt-1" onClick={onRetry}>
          retry
        </button>
      )}
    </div>
  );
}
